import api from "@/lib/api";

const newJobId = () => {
  try { if (window.crypto?.randomUUID) return window.crypto.randomUUID(); } catch { /* context nesecurizat: folosim alternativa */ }
  return "j" + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
};
const sleep = (ms) => new Promise(r => setTimeout(r, ms));
const failure = (status, detail) => Object.assign(new Error(detail), { response: { status, data: { detail } } });

/**
 * Trimite un fișier Excel de import. Serverul îl rulează ÎN FUNDAL (cererea se încheie imediat), deci nu mai depinde de
 * timpul maxim al unei cereri (proxy/nginx: înainte, un import lung dădea „timed out” deși se termina). Cât timp rulează,
 * raportează progresul:
 *  - `{ stage: "upload", percent }` cât timp fișierul se încarcă;
 *  - `{ stage: "server", phase, done, total, percent, elapsed_s }` cât timp serverul îl prelucrează (interogat din ~0,6 în 0,6 s).
 * Întoarce `{ data: raportul }`, exact ca un `api.post`; la eroare aruncă o excepție cu `response.data.detail` (mesajul serverului).
 */
export async function postImport(path, file, onProgress = () => {}) {
  const job = newJobId();
  const fd = new FormData(); fd.append("file", file);
  onProgress({ stage: "upload", percent: 0 });
  const r = await api.post(path, fd, {
    headers: { "Content-Type": "multipart/form-data", "X-Import-Job": job, "X-Import-Async": "1" },
    onUploadProgress: (e) => { if (e.total) onProgress({ stage: "upload", percent: Math.round(e.loaded * 100 / e.total) }); },
  });
  if (!r.data?.async) return r;                    // răspuns direct (server fără import în fundal)
  let notFound = 0, trouble = 0;
  for (;;) {
    await sleep(600);
    let p = null;
    try { p = (await api.get(`/import/progress/${job}`)).data; notFound = 0; trouble = 0; }
    catch (e) {
      if (e?.response?.status === 404) notFound += 1; else trouble += 1;
      if (notFound >= 8) throw failure(404, "Serverul nu mai are importul în lucru (probabil a fost repornit). Verifică în listă ce s-a importat înainte să încerci din nou.");
      if (trouble >= 50) throw failure(503, "Nu mai primesc răspuns de la server. Verifică în listă ce s-a importat înainte să încerci din nou.");
      continue;
    }
    if (p.finished) {
      if (p.error) throw failure(p.error.status, typeof p.error.detail === "string" ? p.error.detail : JSON.stringify(p.error.detail));
      return { data: p.result };
    }
    onProgress({ stage: "server", ...p });
  }
}
